import React from 'react';

/**
 * MiniStat
 * ------------------------------------------------------------------
 * Small bordered box with a muted label on top and a value below.
 * Used in rows of 2-3 inside KPI cards, e.g.
 *   Primary / Secondary / Tertiary   (City card)
 *   Active / Past / Future           (Total Projects card)
 *   Pending / Accepted / Declined    (Invites Available card)
 *
 * Render a row of these inside a flex/grid wrapper in the parent
 * KPI card - MiniStat itself only owns the box styling.
 *
 * @param {string} label
 * @param {string|number} value
 * @param {string} color - color variant for styling
 */
const MiniStat = ({ label, value, className = '', color = '' }) => {
  const colorClass = color ? `mini-stat--${color}` : '';
  return (
    <div className={`mini-stat ${colorClass} ${className}`}>
      <span className="mini-stat__label">{label}</span>
      <span className="mini-stat__value">{value}</span>
    </div>
  );
};

/**
 * MiniStatRow
 * ------------------------------------------------------------------
 * Convenience wrapper that lays out 2-3 MiniStats evenly in a row.
 * Purely a flex helper - safe to skip and use your own wrapper.
 */
export const MiniStatRow = ({ children, className = '' }) => (
  <div className={`mini-stat-row ${className}`}>{children}</div>
);

export default MiniStat;